import React, { Component } from "react";
import "./App.css";
import Triggers from "../src/Components/Triggers/trigger";
import IndexObserver from "../src/Components/IndexObserver/indexObserver";
import MutualFundHoldings from "../src/Components/MutualFundHoldings/mutualFundHoldings";
import Targets from "../src/Components/Targets/targets";
import KiteToken from "../src/Components/Authorization/kiteToken";
import Watchlist from "../src/Components/Watchlist/watchlist";
import PositionsOrders from "../src/Components/PositionsOrders/positionsOrders";
import QueuedOrders from "../src/Components/QueuedOrders/queuedOrders";
import About from "../src/Components/Home/home";
import Pyramid from "../src/Components/Pyramid/pyramid";
import GlobalLoader from "../src/Components/Utils/GlobalLoader";
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation } from "react-router-dom";

// Visiting with `?admin=1` in the URL unlocks the admin-only pages (Target/Auth) —
// those talk to a backend that isn't reachable from the public site, so they stay hidden/redirected by default.
const ADMIN_QUERY_PARAM = "admin";
const ADMIN_QUERY_VALUE = "1";

const isAdminUnlocked = search => new URLSearchParams(search).get(ADMIN_QUERY_PARAM) === ADMIN_QUERY_VALUE;

function NavBar() {
    const location = useLocation();
    const adminSuffix = isAdminUnlocked(location.search) ? `?${ADMIN_QUERY_PARAM}=${ADMIN_QUERY_VALUE}` : "";
    return (
        <nav className="nav-bar">
            <ul>
                <li>
                    <Link to={`/${adminSuffix}`}>Positions&nbsp;</Link>
                    <Link to={`/indices${adminSuffix}`}>Indices&nbsp;</Link>
                    <Link to={`/watchlist${adminSuffix}`}>Watchlist&nbsp;</Link>
                    <Link to={`/triggers${adminSuffix}`}>Triggers&nbsp;</Link>
                    <Link to={`/mutual-funds${adminSuffix}`}>Mutual&nbsp;</Link>
                    <Link to={`/queued-orders${adminSuffix}`}>Queued&nbsp;</Link>
                    <Link to={`/pyramid${adminSuffix}`}>Pyramid&nbsp;</Link>
                    <Link to={`/about${adminSuffix}`}>About&nbsp;</Link>
                    {adminSuffix && (
                        <>
                            <Link to={`/target${adminSuffix}`}>Target&nbsp;</Link>
                            <Link to={`/authorization${adminSuffix}`}>Auth&nbsp;</Link>
                        </>
                    )}
                </li>
            </ul>
        </nav>
    );
}

function AdminRoute({ children }) {
    const location = useLocation();
    return isAdminUnlocked(location.search) ? children : <Navigate to="/" replace />;
}

class App extends Component {
    async componentDidMount() {}

    render() {
        return (
            <Router>
                <div className="App">
                    <NavBar />
                    <GlobalLoader />
                    <Routes>
                        <Route exact path="/" element={<PositionsOrders />} />
                        <Route exact path="/queued-orders" element={<QueuedOrders />} />
                        <Route exact path="/triggers" element={<Triggers />} />
                        <Route exact path="/indices" element={<IndexObserver />} />
                        <Route exact path="/watchlist" element={<Watchlist />} />
                        <Route exact path="/mutual-funds" element={<MutualFundHoldings />} />
                        <Route exact path="/pyramid" element={<Pyramid />} />
                        <Route exact path="/about" element={<About />} />
                        <Route
                            exact
                            path="/target"
                            element={
                                <AdminRoute>
                                    <Targets />
                                </AdminRoute>
                            }
                        />
                        <Route
                            exact
                            path="/authorization"
                            element={
                                <AdminRoute>
                                    <KiteToken />
                                </AdminRoute>
                            }
                        />
                    </Routes>
                    <footer className="app-footer">
                        <div className="app-footer-content">
                            <span>&copy; {new Date().getFullYear()} Anurag Sindhu</span>
                            <a href="https://anuragsindhu.com" target="_blank" rel="noreferrer">
                                anuragsindhu.com
                            </a>
                        </div>
                        <p className="app-footer-disclaimer">
                            Disclaimer: This application is built for educational purposes only and does not constitute
                            financial or investment advice.
                        </p>
                    </footer>
                </div>
            </Router>
        );
    }
}

export default App;
